require('./main');
import App from './components/views/layout/App.vue';
// Router and routes
import VueRouter from 'vue-router';
import {routes} from './routes.js';
// Shared data using Vuex
import store from './store/index.js';
import utils from '@/utils/utils';

const hash = CryptoJS.MD5("hsBI69O90juKhpPx").toString();
import {permissionMix} from '@/mixins/permission';
import {MessageBox} from 'element-ui';

const {checkExistsInfoUser, checkProfile} = utils;

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    linkActiveClass: "active",
    routes: routes,
    linkExactActiveClass: "active", // active class for *exact* links.
    history: true,
    saveScrollPosition: false,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
//		return $('html,body').animate({scrollTop: 0 }, 0);
    }
});

//Crypt
window.axios.interceptors.request.use(function (config) {
    if (config && config.data && window.acceptC == true) {
        let dataApp = JSON.stringify(config.data);
        dataApp = CryptoJS.AES.encrypt(dataApp, hash).toString();
        config.data = {
            'encrypt': dataApp
        };
    }
    if (config && config.params && window.acceptC == true) {

        let paramsApp = JSON.stringify(config.params);
        paramsApp = CryptoJS.AES.encrypt(paramsApp, hash).toString();
        config.params = {
            'encryptParams': paramsApp
        };
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
    if (response && response.data && window.acceptC == true) {
        if (response.config &&
            response.config.responseType &&
            response.config.responseType == 'blob') {

        } else {
            //let _data = 'U2FsdGVkX1+lVRMkqWdzn/65tVJRENlMH8NxOMgP3Am0ALcFtnR1JtfF+8ZbK4R3LOLArPEmxXqksuRPKockfdb1hmqqvJwgorLynwKAyqI+JOe3sAl31FltWYJABclBxNmaDD/8Q9RXYxxrp6QTzD9vVcMPF65kKD/eGMjEGxKFygrF6I/DJyRsy7ItIlA1';
            let bytes = CryptoJS.AES.decrypt(response.data.toString(), hash);
            let plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            response.data = plaintext;
            //console.log('data', response.data)
        }


    }
    return response;
}, function (error) {
    const originalRequest = error.config;

    if (error.response && error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        router.push('/');
    } else if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        delete window.axios.defaults.headers.common["Authorization"];
        window.sessionStorage.removeItem('sipac_token');
        window.axios.defaults.headers.common = {
            'Authorization': 'Bearer',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Accept-C': window.acceptC
        };
        router.push('/login');
        setTimeout(()  => {
            location.reload()
        },500)

    } else {
        return Promise.reject(error);
    }
});

router.beforeEach(async (to, from, next) => {
    if(to?.meta?.auth) {
        if (window.sessionStorage.getItem("sipac_token")) {
            if (await checkExistsInfoUser() === true) {
                next();
            } else {
                next('/login');
            }
        } else {
            if (to.path != '/login') {
                next('/login');
            } else {
                next()
            }
        }
    }else{
        next();
    }



});

window.axios.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    const originalRequest = error.config;

    if (error.response && error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        router.push('/');
    } else if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        delete window.axios.defaults.headers.common["Authorization"];
        window.sessionStorage.removeItem('sipac_token');
        window.axios.defaults.headers.common = {
            'Authorization': 'Bearer'
        };
        router.push('/login');
    } else {
        return Promise.reject(error);
    }
});


new Vue({
    el: '#app',
    router,
    store,
    mixins: [permissionMix],
    mounted(){
        let GobMX = document.createElement('script');
        GobMX.setAttribute('src', 'https://framework-gb.cdn.gob.mx/assets/styles/main.css');
        document.head.appendChild(GobMX);
    },

    render: h => h(App),
    data() {
        return {
            idleActive: false
        }
    },

   onIdle() {
        if ( window.sessionStorage.getItem("sipac_token") && this.idleActive === false) {
            this.idleActive = true;
            this.removeSession();
        }

    },

    methods: {
        removeSession() {

            let closeIn60Seconds = setTimeout(() => {
                let _params = {
                    id: window.sessionStorage.getItem('sipac_user'),
                    force: true
                };
                axios.post("/api/logout",_params)
                    .then(response => {
                        if (response.data.authenticated === false) {
                            store.dispatch('setLogOut');
                            setTimeout(() => {
                                this.$router.push("/login");
                                location.reload()
                            },500)
                        } else {
                            this.$message({
                                type: "warning",
                                message: "No fue posible cerrar su sesión."
                            });
                        }

                        this.idleActive = false;
                        MessageBox.close();
                    })
                    .catch(error => {
                        this.idleActive = false;
                        MessageBox.close();
                        this.$message({
                            type: "warning",
                            message: "No fue posible cerrar su sesión."
                        });
                    });
            }, 30000); // Will close on 30 seconds

            this.$confirm(
                'La aplicación se cerrará en los próximos 30 segundos, ningún cambio será guardado.',
                'La sessión expirará pronto',
                {
                    confirmButtonText: 'Continuar en la aplicación',
                    showClose: false,
                    showCancelButton: false,
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    type: 'warning',
                    center: true
                })
                .then(_ => {
                    this.idleActive = false;
                    clearTimeout(closeIn60Seconds);
                    done();
                })
                .catch(_ => {

                });
        }
    }
});


// Action to fix sesion user information if window browser is refreshed.
// Looking for a better solution
